import React, { FC } from 'react';
import { Button } from '@goldbely/explore-component-library';

import styles from './index.module.sass';

interface SuccessProps {
  onClose: () => void;
}

const Success: FC<SuccessProps> = ({ onClose }) => (
  <div className={`${styles.container} spec__first-order-promotion-requested`}>
    <div className={styles.text}>
      <h1 className={styles.headline}>Thank You!</h1>
      <p className={styles.information}>Your discount code will be emailed&nbsp;to&nbsp;you.</p>
    </div>

    <Button fullWidth type="button" onClick={onClose}>
      Close
    </Button>
  </div>
);

export default Success;
